module.exports = __webpack_public_path__ + "e3cf71044bea6185ccbd619554846791.svg";